import React from 'react';

const ExportModal = ({ 
    show, 
    fileName, 
    onFileNameChange, 
    onExport, 
    onCancel,
    title = 'Export Analytics',
    description = 'Enter a custom filename for your export:'
}) => {
    if (!show) return null;

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onExport();
        }
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000
        }}>
            <div style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                padding: '30px',
                maxWidth: '500px',
                width: '90%',
                boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)'
            }}>
                <h3 style={{ margin: '0 0 20px 0', fontSize: '20px', color: '#333' }}>
                    {title}
                </h3>
                <p style={{ margin: '0 0 15px 0', color: '#666', fontSize: '14px' }}>
                    {description}
                </p>
                <input
                    type="text"
                    value={fileName}
                    onChange={(e) => onFileNameChange(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Enter filename"
                    autoFocus
                    style={{
                        width: '100%',
                        padding: '12px',
                        fontSize: '14px',
                        border: '2px solid #ddd',
                        borderRadius: '6px',
                        marginBottom: '20px',
                        boxSizing: 'border-box',
                        outline: 'none'
                    }}
                />
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button
                        onClick={onCancel}
                        className="filter-action-btn secondary"
                        style={{ margin: 0 }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onExport}
                        className="filter-action-btn export"
                        style={{ margin: 0 }}
                    >
                        📊 Export
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExportModal;
